import React from 'react';
import './PickPackage.scss';
import NumberInput from 'Components/Shared/NumberInput/NumberInput';
import CategoryDropdown from 'Components/CategoryDropdown/CategoryDropdown';

interface IProps {
  name: string;
  packageID: number;
  performanceID: number;
  discountID: number;
  maxNumberOfPackages: number;
  priceCategories: Julius.Website.PriceCategoryViewModel[];
  sectionCategories: Julius.Website.SectionCategoryViewModel[];
  currentSelection: Julius.Website.PackageRequestViewModel;
  onPackageSelection: (request: Julius.Website.PackageRequestViewModel) => void;
}

class PackageSubItem extends React.PureComponent<IProps> {

  onQuantityChange = (value: number) => {
    this.props.onPackageSelection({ ...this.getSelection(), numberOfPackages: value });
  }
  
  onPriceCategoryChange = (priceCategoryID: number) => {
    const price = this.getPriceCategoryPrice(priceCategoryID);
    this.props.onPackageSelection({ ...this.getSelection(), priceCategoryID, price });
  }

  onSectionCategoryChange = (sectionID: number) => {
    this.props.onPackageSelection({ ...this.getSelection(), sectionID });
  }

  isMaxNumberOfPackages = () => {
    return this.getSelection().numberOfPackages === this.props.maxNumberOfPackages;
  }

  getPriceCategoryPrice = (priceCategoryID: number) => {
    const { priceCategories } = this.props;
    return priceCategories.find(p => p.id === priceCategoryID).price;
  }

  getSelection = () => {
    const { currentSelection } = this.props;
    const defaultPriceCategoryID = this.props.priceCategories[0].id;
    const defaultSectionID = this.props.sectionCategories[0].id;

    return currentSelection ? currentSelection : {
      packageID: this.props.packageID,
      performanceID: this.props.performanceID,
      discountID: this.props.discountID,
      priceCategoryID: defaultPriceCategoryID,
      sectionID: defaultSectionID,
      price: this.getPriceCategoryPrice(defaultPriceCategoryID),
      numberOfPackages: 0,
    };
  }

  render() {
    const { priceCategories, sectionCategories } = this.props;

    if (
      !priceCategories || !priceCategories.length ||
      !sectionCategories || !sectionCategories.length
    ) {
      return null;
    }

    const isMaxNumberOfPackages = this.isMaxNumberOfPackages();
    const currentSelection = this.getSelection();
  
    return (
      <div className='package-sub-item'>
        <div className='name'>{ this.props.name }</div>
        <CategoryDropdown 
          categories={ priceCategories }
          selectedCategoryID={ currentSelection.priceCategoryID }
          onSelect={ this.onPriceCategoryChange }
        />
        <NumberInput 
          value={ currentSelection.numberOfPackages }
          isIncrementDisabled={ isMaxNumberOfPackages }
          onChange={ this.onQuantityChange }
        />
      </div>
    );
  }
};

export default PackageSubItem;


// WEBPACK FOOTER //
// ./src/components/PickPackage/PackageSubItem.tsx